"use client";

/**
 * Below-the-fold footer with deferred JS hydration.
 *
 * Root layout used to mount a dynamic Footer with ssr:true, which still
 * hydrated during the initial long-task window. IdleMount waits until the
 * browser is idle (or ~2s) before loading the footer chunk, which frees the
 * main thread for LCP / TTI. The outer shell keeps min-height so CLS stays flat.
 */

import dynamic from "next/dynamic";
import { IdleMount } from "@/components/ui/idle-mount";

const FooterSection = dynamic(
  () =>
    import("@/components/ui/footer-section").then((m) => m.FooterSection),
  {
    ssr: false,
    loading: () => null,
  }
);

export function DeferredFooter() {
  return (
    // Shell reserves footer height before the dynamic chunk mounts (CLS).
    <div className="relative border-t bg-background min-h-[280px]">
      <IdleMount timeoutMs={2500}>
        <FooterSection />
      </IdleMount>
    </div>
  );
}
